import React from "react";
import '../styles/modules/_footer.scss';

export default function Footer() {
   return (
      <div className="footer">
         <div className="page-wrapper footer-inner">
            <div className="footer__copyright">Copyright © 2021 by M&P. All rights reserved.</div>
         </div>
      </div>
   )
}